export default __webpack_public_path__ + "static/media/Celular.b5eeb703.png";